import React from 'react';
import { AlertCircle, AlertTriangle, X } from 'lucide-react';

const daysLeft = (iso) => {
  if (!iso) return null;
  return Math.ceil((new Date(iso) - new Date()) / 86400000);
};

export default function SubscriptionWarningBanner({ validUntil, compact = false, onDismiss }) {
  const days = daysLeft(validUntil);
  if (days === null || days > 30 || days < 0) return null;

  let bg, border, textColor, Icon, headline, detail;

  if (days <= 7) {
    bg        = 'bg-red-50';
    border    = 'border-red-300';
    textColor = 'text-red-800';
    Icon      = AlertTriangle;
    headline  = `Subscription expires in ${days} day${days !== 1 ? 's' : ''}`;
    detail    = 'System access will stop once it expires — contact the admin immediately to renew.';
  } else if (days <= 14) {
    bg        = 'bg-orange-50';
    border    = 'border-orange-300';
    textColor = 'text-orange-800';
    Icon      = AlertTriangle;
    headline  = `Subscription ending soon — ${days} days left`;
    detail    = 'Reach out to the admin to renew before access is interrupted.';
  } else {
    bg        = 'bg-amber-50';
    border    = 'border-amber-200';
    textColor = 'text-amber-800';
    Icon      = AlertCircle;
    headline  = `Subscription ends in ${days} days`;
    detail    = 'Contact the admin to arrange renewal.';
  }

  if (compact) {
    return (
      <span className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-md text-xs font-medium ${bg} ${border} border ${textColor}`}>
        <Icon className="h-3 w-3 shrink-0" />
        <span>{headline}</span>
        {onDismiss && (
          <button
            onClick={onDismiss}
            className="ml-0.5 opacity-60 hover:opacity-100 transition-opacity"
            aria-label="Dismiss"
          >
            <X className="h-3 w-3" />
          </button>
        )}
      </span>
    );
  }

  return (
    <div className={`flex items-center gap-3 ${bg} border-b ${border} px-4 py-2.5 text-sm ${textColor}`}>
      <Icon className="h-4 w-4 flex-shrink-0" />
      <span>
        <strong>{headline}.</strong>{' '}
        {detail}
      </span>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="ml-auto opacity-60 hover:opacity-100 transition-opacity"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
